/* eslint-disable quote-props */
import {UserRole} from './user-role.model';
import {User} from './user.model';
import {Principal} from './principal.service';

export class PrincipalUtils {
  //Main roles should not be combined as it could make some breaking bugs
  static MAIN_ROLES: string[] = [UserRole.ADMIN, UserRole.SALES_REPRESENTATIVE, UserRole.READ_ONLY_ADMIN, UserRole.CAMPAIGN_MANAGER, UserRole.REV_OPS, UserRole.DESIGNER];
  //Additional roles that can be combined with Main Roles
  static ADDITIONAL_ROLES: string[] = [UserRole.PUBLISHER, UserRole.CONTENT_OWNER];
  static APP_MAP: { [key: string]: UserRole } = {
    'admin': UserRole.ADMIN,
    'publisher': UserRole.PUBLISHER,
    'co': UserRole.CONTENT_OWNER,
    'sr': UserRole.SALES_REPRESENTATIVE,
    'cm': UserRole.CAMPAIGN_MANAGER,
    'ro': UserRole.REV_OPS,
    'ds': UserRole.DESIGNER,
    'admin-readonly': UserRole.READ_ONLY_ADMIN,
  };

  static hasMoreThanOneMainRole(user: User) {
    return user.roles.filter(r => this.MAIN_ROLES.includes(r)).length > 1;
  }

  static isMasked(principal: Principal) {
    console.log('isMasked %s', JSON.stringify(principal.mask));
    const hasMaskRole = principal.mask.role;
    if (hasMaskRole) {
      switch (hasMaskRole) {
        case UserRole.ADMIN:
          return true;
        case UserRole.PUBLISHER:
          return !!principal.mask.publisherId;
        case UserRole.CONTENT_OWNER:
          return true;
        case UserRole.SALES_REPRESENTATIVE:
          return true;
        case UserRole.CAMPAIGN_MANAGER:
          return false;
        case UserRole.READ_ONLY_ADMIN:
          return true;
        case UserRole.REV_OPS:
          return true;
        case UserRole.DESIGNER:
          return true;
      }
    }
    return false;
  }


  static filterMainRoles(roles: string[]) {
    return roles.filter(r => this.MAIN_ROLES.includes(r));
  }
}
